// @flow

import { deviceTypeMessages, deviceModelTypeMessages } from './intl';

export const findDeviceTypeMessage = (type: string, manufacturer: string = '', model: string = '') =>
    deviceTypeMessages[`${type}-${manufacturer}`] ||
    deviceModelTypeMessages[model] ||
    deviceTypeMessages[`${type}-${model}`] ||
    deviceTypeMessages[type];



// WEBPACK FOOTER //
// ./src/core/translations/devices/index.js